var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarmCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 43,
    viewBox: "0 0 36 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2267 21.4998V23.7142C31.9419 24.1817 34 26.5316 34 29.3612V30.1363C34 33.3104 31.4088 35.8817 28.21 35.8817H7.79C4.59124 35.8817 2 33.3104 2 30.1363V29.3612C2 26.5439 4.05812 24.194 6.77334 23.7142V17.3045C6.77334 11.5344 11.4847 6.85938 17.2995 6.85938H18.7005C21.1912 6.85938 23.4794 7.71713 25.2817 9.15127",
    stroke: "#102D3E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0049 7.10567V4.96498C15.0049 3.3287 16.3439 2 17.9929 2C19.6418 2 20.9809 3.3287 20.9809 4.96498V7.10567",
    stroke: "#102D3E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9691 35.8945V38.0352C20.9691 39.6715 19.6301 41.0002 17.9812 41.0002C16.3322 41.0002 14.9932 39.6715 14.9932 38.0352V35.8945",
    stroke: "#102D3E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7959 14.1795L23.684 19.4428L30.9613 10.3789",
    stroke: "#102D3E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmCompleted);
export default __webpack_public_path__ + "static/media/AlarmCompleted.a9c6d9e1bb9986f55b8cfeed00a93d71.svg";
export { ForwardRef as ReactComponent };